import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { SwPartNumber } from '../../../../../shared/models/sw-part-number/sw-part-number';
import { HeaderSorterComponent } from '../../../common/tables/header-sorter/header-sorter.component';
import { getPropertyName } from '../../../../common/common-utils';
import { SortingConfiguration } from '../../../../../shared/internal/sorting-configuration';
import { BaseQuery } from '../../../../../shared/models/base/base-query';
import { ScrollableBase } from '../../../base/scrollable-base';

@Component({
  selector: 'app-sw-part-number-recycling-table',
  imports: [HeaderSorterComponent],
  templateUrl: './sw-part-number-recycling-table.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './sw-part-number-recycling-table.component.scss',
})
export class SwPartNumberRecyclingTableComponent extends ScrollableBase<null> {
  @Input() public recycledSwPartNumbers?: SwPartNumber[];
  @Output() public sortByFieldChanged: EventEmitter<BaseQuery> = new EventEmitter<BaseQuery>();

  public getPropertyName = getPropertyName<SwPartNumber>;
  public sortingConfiguration = new SortingConfiguration(this.getPropertyName('number'));

  private baseQuery = {} as BaseQuery;

  public sortBy(field: string): void {
    const sortByField = this.sortingConfiguration.sortBy(field);
    if (this.baseQuery) {
      this.baseQuery.orderBy = sortByField.field;
      this.baseQuery.orderByDescending = sortByField.orderByDescending;
      this.sortByFieldChanged.emit(this.baseQuery);
    }
  }
}
